import { Link } from "react-router-dom"
import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { useAuthStore } from "@/features/auth/store"
import { initialsFromName } from "@/lib/initials"

export function SidebarUserFooter() {
  const user = useAuthStore((s) => s.user)
  if (!user) return null

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton asChild size="lg" tooltip={user.fullName}>
          <Link to="/me">
            <Avatar className="size-8">
              <AvatarFallback className="bg-primary text-primary-foreground text-xs">
                {initialsFromName(user.fullName)}
              </AvatarFallback>
            </Avatar>
            <div className="flex min-w-0 flex-col text-left">
              <span className="truncate text-sm font-medium leading-tight">
                {user.fullName}
              </span>
              <span className="truncate text-xs text-muted-foreground leading-tight">
                {user.superuser ? "superuser" : "użytkownik"}
              </span>
            </div>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
